"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LayerForm = require("./LayerForm");
Object.keys(_LayerForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayerForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LayerForm[key];
    }
  });
});